import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";

import Header, { NavLink, NavLinks, PrimaryLink, LogoLink, NavToggle, DesktopNavLinks } from "../headers/light.js";
import BackgroundAsImage from "components/hero/BackgroundAsImage.js";

const StyledHeader = styled(Header)`
  ${tw`pt-8 max-w-none`}
  ${DesktopNavLinks} ${NavLink}, ${LogoLink} {
    ${tw`text-gray-100 hover:border-gray-300 hover:text-gray-300`}
  }
  ${NavToggle}.closed {
    ${tw`text-gray-100 hover:text-primary-500`}
  }
`;
/*
let Container = styled.div`
  ${tw`relative -mx-8 -mt-4 bg-center bg-cover`}
  background-image: url("/assets/img/slide2.jpg");
`;
*/
const OpacityOverlay = tw.div`z-10 absolute inset-0 bg-primary-500 opacity-25`;

const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;
const RightColumn = tw.div`w-full sm:w-5/6 lg:w-1/2 mt-16 lg:mt-0 lg:pl-8`;

const Heading = styled.h1`
  ${tw`text-3xl text-center lg:text-left sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-100 leading-none`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SlantedBackground = styled.span`
  ${tw`relative text-primary-500 px-4 -mx-4 py-2`}
  &::before {
    content: "";
    ${tw`absolute inset-0 bg-gray-100 transform -skew-x-12 -z-10`}
  }
`;

const Notification = tw.span`inline-block my-4 pl-3 py-1 text-gray-100 border-l-4 border-blue-500 font-medium text-sm`;

const PrimaryAction = tw.button`px-8 py-3 mt-10 text-sm sm:text-base sm:mt-16 sm:px-8 sm:py-4 bg-gray-100 text-primary-500 font-bold rounded shadow transition duration-300 hocus:bg-primary-500 hocus:text-gray-100 focus:shadow-outline`;
const images=['/assets/img/slide_1.jpg','/assets/img/slide_2.jpg','/assets/img/slide_3.jpg','/assets/img/slide_4.jpg'];
let i=0;

let slide=images[2];

export default () => {
  
  const [image,setImage]=useState('/assets/img/slide_3.jpg');
  
  useEffect(()=>{      
    slider();
  },[])
  const slider=()=>{
    
    setInterval(()=>{
      console.log("No:"+i);
      
      slide=images[i];
      setImage(slide)           
      
      if(i==3){
        i=0;
      }
      i++;
    },10000)
  }
  var Container = styled.div`
  ${tw`relative -mx-8 -mt-4 bg-center bg-cover`}
  background-image: url('${image}');
  `;
  const navLinks = [
    <NavLinks key={1}>
      <NavLink href="/">
        Home
      </NavLink>
      <NavLink href="/AboutUs">
        About Us
      </NavLink>
      <NavLink href="/Services">
        Services
      </NavLink>
      <NavLink href="/Package">
        Packages
      </NavLink>
      <NavLink href="/faq">
        FAQ
      </NavLink>
      
    </NavLinks>,
    <NavLinks key={2}>
      <PrimaryLink href="/ContactUs">
        Contact Us
      </PrimaryLink>
    </NavLinks>
  ];

  return (
    <Container>
      <OpacityOverlay />
      <HeroContainer>
        <StyledHeader links={navLinks} />
        <TwoColumn>
          <LeftColumn>
            <Notification>Your Road, Your Ride, Your Way</Notification>
            <Heading>
              <span>Rent the best car </span>
              <br />
              <SlantedBackground>With Sonali Tours & Travels</SlantedBackground>
            </Heading>
            
          </LeftColumn>
          <RightColumn>
            
          </RightColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
